(function () {
  'use strict';
  const bound = new WeakSet();
  function mute(video) {
    if (!video.muted) video.muted = true;
    if (!video.defaultMuted) video.defaultMuted = true;
    if (video.volume !== 0) video.volume = 0;
    if (!video.hasAttribute('muted')) video.setAttribute('muted', '');
  }
  function bindVideo(video) {
    mute(video);
    if (bound.has(video)) return;
    bound.add(video);
    ['play', 'volumechange', 'loadedmetadata'].forEach(event => video.addEventListener(event, () => mute(video)));
  }
  function muteEmbed(frame) {
    const src = frame.getAttribute('src');
    if (!src) return;
    try {
      const url = new URL(src, location.href);
      const youtube = /^(www\.)?youtube(-nocookie)?\.com$/.test(url.hostname) && url.pathname.startsWith('/embed/');
      const vimeo = url.hostname === 'player.vimeo.com' && url.pathname.startsWith('/video/');
      if (!youtube && !vimeo) return;
      const key = youtube ? 'mute' : 'muted';
      if (url.searchParams.get(key) !== '1') {
        url.searchParams.set(key, '1');
        frame.setAttribute('src', url.href);
      }
    } catch (error) {}
  }
  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches('video')) bindVideo(root);
    if (root.matches && root.matches('iframe')) muteEmbed(root);
    root.querySelectorAll('video').forEach(bindVideo);
    root.querySelectorAll('iframe').forEach(muteEmbed);
  }
  scan(document);
  document.addEventListener('play', event => { if (event.target.tagName === 'VIDEO') bindVideo(event.target); }, true);
  new MutationObserver(records => records.forEach(record => {
    if (record.type === 'attributes') scan(record.target);
    else record.addedNodes.forEach(scan);
  })).observe(document.documentElement, {childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'muted']});
})();
